import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { notify } from 'react-notify-toast';
import clientAxios from '../../clients/clientAxios';
import CareersList from './CareersList';
import EditCareer from './EditCareer';

export default function Careers() {
  const [isLoading, setIsLoading] = useState(true);
  const [carreras, setCarreras] = useState([]);
  const [orderBy, setOrderBy] = useState('-createdAt');
  const [sortBy, setSortBy] = useState('createdAt');
  const [showEditCarrera, setShowEditCarrera] = useState(false);
  const [selectedCarrera, setSelectedCarrera] = useState(null);

  const headerConfig = {
    headers: { 'auth-token': localStorage.getItem('JWT') || ' ' },
  };

  useEffect(() => {
    getCarreras();
    //eslint-disable-next-line
  }, [orderBy, sortBy]);

  const getCarreras = async () => {
    try {
      setIsLoading(true);
      const { data } = await clientAxios.get('/carreers', {
        params: { orderBy, sortBy },
        ...headerConfig,
      });
      setCarreras(data || []);
      setIsLoading(false);
    } catch (error) {
      notify.show(
        error?.response?.data?.message || 'Error al cargar las carreras',
        'error'
      );
      setIsLoading(false);
    }
  };

  const handleEditCarrera = (carrera) => {
    setSelectedCarrera(carrera);
    setShowEditCarrera(true);
  };

  const handleCarreraSaved = () => {
    getCarreras();
    setShowEditCarrera(false);
    setSelectedCarrera(null);
  };

  return (
    <Container className='mt-5'>
      <Row className='mb-4'>
        <Col>
          <h1>Gestion de Carreras</h1>
        </Col>
      </Row>

      <CareersList
        carreras={carreras}
        isLoading={isLoading}
        onEdit={handleEditCarrera}
      />

      {selectedCarrera && (
        <EditCareer
          show={showEditCarrera}
          onHide={() => setShowEditCarrera(false)}
          carrera={selectedCarrera}
          onSave={handleCarreraSaved}
        />
      )}
    </Container>
  );
}